import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import './index.css';
import { WalletContext } from './wallet-context';

const THEME = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: 'rgb(34,193,195)',
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={THEME}>
      <WalletContext>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </WalletContext>
    </ThemeProvider>
  </React.StrictMode>,
  document.querySelector('#root')
);
